import React from 'react';
import './sidebar-container.styles.scss';
import { useSelector } from 'react-redux';
import SidebarLeft from './sidebar-left.component';

const SidebarLeftContainer = ({ 
    setShowFeedbackModal,
    toggleMenu 
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);

    return (
        <div className={`sidebar-left-container ${screenSize}`}>
            <div className={`${screenSize === 'desktop' && 'g-card'}`}>
                <SidebarLeft 
                toggleMenu={toggleMenu}
                setShowFeedbackModal={setShowFeedbackModal} />
            </div>
        </div>
    )
}

export default SidebarLeftContainer